export default "https://cdn-static.gokick.com/assets/545fd9dea55dc30417fabffa3a2a88024697daac/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";